<template>
  <el-dialog
    class="radish-dia"
    title="请输入搜索条件名称"
    width="400px"
    height="200px"
    top="70px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="radish-dia-body"><el-input v-model="conName" size="mini"> </el-input></div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data: function() {
    return {
      dialogVisible: false,
      conName: '',
      condition: {},
      type: null,
    }
  },
  methods: {
    show: function(condition, type) {
      // console.log(condition)
      this.condition = condition
      if (type) this.type = type
      this.dialogVisible = true
    },
    handleConfirm: async function() {
      if (this.conName) {
        const dt = { name: this.conName, condition: this.condition }
        if (this.type) dt.type = this.type
        const res = await app.service('radish').addCondition(dt)
        if (res.status == 'success') {
          this.conName = ''
        }
        this.$message.success({ duration: 500, message: '保存成功' })
        this.dialogVisible = false
      } else {
        this.$message.warning('请输入名称')
      }
    },
  },
}
</script>
